<template>
  <v-card align="center" justify="center" light min-width="30vw" outlined>
    <v-card-title style="background-color: #d2d7e1">
      <v-list-item>
        <v-list-item-title><h2>{{ $t('title') }}</h2></v-list-item-title>
        <v-spacer/>
        <v-list-item-action>
          <v-icon class="icon" icon @click="close">fa-times</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-card-title>
    <v-card-text class="px-3 pb-5 pt-1">
      <v-overlay :absolute="true" :value="overlayProcessing"><v-progress-circular :size="70" width="5" indeterminate/></v-overlay>
      <v-container v-if="view === 'GENERAL'" fluid>
        <v-row class="mx-3" align="center" justify="center">
          <h2>{{ $t('subtitle') }}</h2>
          <v-btn v-if="new Date($store.state.tournament.endTime) > new Date()" class="button-add ml-3" @click="view = 'ADD'" small>
            {{ $t('btnAdd') }} <v-icon class="ml-2" color="white" small>fa-plus</v-icon></v-btn>
          <v-spacer/>
          <v-text-field :label="$t('hintSearch')" prepend-icon="fa-search" v-model="search"/>
        </v-row>
        <v-data-table style="min-width: 42vw" :items="$store.state.tournament.participants" :headers="headers" hide-default-footer dense :search="search">
          <template v-slot:item.score="{ item }">
            <p class="mb-0">{{ (item.score !== null)? item.score.toFixed(2) : 0 }}</p>
          </template>
          <template v-slot:item.status="{ item }">
            <v-chip :color="statusColor(item.status)" x-small>{{ getStatus(item.status) }}</v-chip>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-chip v-if="item.status === 'ACTIVE'" x-small @click="goToUser(item, 'DISQUALIFY')">{{ $t('btnDisqualify') }}</v-chip>
            <v-chip v-else x-small @click="goToUser(item, 'ACTIVATE')">{{ $t('btnActivate') }}</v-chip>
            <v-chip v-if="canSeeJournal" x-small class="ml-2" @click="seeJournal(item)">{{ $t('btnSeeJournal') }}</v-chip>
          </template>
        </v-data-table>
        <h4 v-if="$store.state.tournament.participants.length > 10" class="my-7">And {{ $store.state.tournament.participants.length - 10 }} more tournament participants</h4>
        <v-chip @click="exportCSV" class="mt-2" small>{{ $t('btnDownload') }} <v-icon class="ml-2" x-small>fa-share</v-icon></v-chip>
        <v-row class="mt-5" align="center" justify="center">
          <v-btn @click="close">{{ $t('btnClose') }}</v-btn>
        </v-row>
      </v-container>
      <v-container v-else-if="view === 'ADD'" fluid>
        <h2 class="text-center my-3">{{ $t('add.title') }}</h2>
        <p class="text-center mb-10">{{ $t('add.description') }}</p>
        <v-autocomplete :items="this.$store.state.clubMembers" :label="$t('add.emailLabel')" :placeholder="$t('add.emailPlaceholder')"
                  item-value="user.id" item-text="user.email" v-model="userId" @change="changedSelectedUser" outlined/>
        <v-select :disabled="userId === 0" :items="userVerifiedBrokerAccounts" :label="$t('add.accountLabel')" :placeholder="$t('add.accountPlaceholder')" item-value="id" item-text="identifier" v-model="brokerAccountId" outlined/>
        <v-row class="mt-5" align="center" justify="center">
          <v-btn @click="view = 'GENERAL'">« {{ $t('add.btnAll') }}</v-btn>
          <v-btn :disabled="userId === 0 || brokerAccountId === 0" class="ml-3" @click="addParticipant">{{ $t('add.btnAdd') }}</v-btn>
        </v-row>
      </v-container>
      <v-container v-else-if="currentParticipant !== null" fluid>
        <h2 class="text-center mt-3">{{ (view === 'DISQUALIFY')? $t('option.titleDisqualify') : $t('option.titleActivate') }}</h2>
        <v-avatar size="100" class="my-7">
          <v-img :src="currentParticipant.profilePicture !== null?
          currentParticipant.profilePicture : 'https://upload.wikimedia.org/wikipedia/commons/d/d3/User_Circle.png'" contain></v-img>
        </v-avatar>
        <p class="text-center">
          {{ (view === 'DISQUALIFY')? $t('option.descriptionDisqualify', { name: currentParticipant.firstName }) :
            $t('option.descriptionActivate', { name: currentParticipant.firstName }) }}
        </p>
        <v-row class="mt-5" align="center" justify="center">
          <v-btn @click="view = 'GENERAL'">« {{ $t('option.btnAll') }}</v-btn>
          <v-btn v-if="view === 'DISQUALIFY'" class="ml-3" @click="disqualifyUser">{{ $t('option.btnDisqualify', { name: currentParticipant.firstName }) }}</v-btn>
          <v-btn v-else class="ml-3" @click="activateUser">{{ $t('option.btnActivate', { name: currentParticipant.firstName }) }}</v-btn>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import RepositoryTournament from '../../../repositories/tournament';
import RepositoryBroker from '../../../repositories/brokerAccount';
import { mapMutations } from 'vuex';
export default {
  name: "TournamentParticipants",
  props: {
    tournamentSummary: Object,
  },
  data() {
    return {
      canSeeJournal: false,
      overlayProcessing: false,
      view: 'GENERAL',
      search: '',
      headers: [
        { text: this.$t('headers.name'), align: 'left', value: 'firstName', sortable: false },
        { text: this.$t('headers.email'), align: 'left', value: 'email', sortable: false },
        { text: this.$t('headers.username'), align: 'left', value: 'username', sortable: false },
        { text: this.$t('headers.score'), align: 'left', value: 'score', sortable: false },
        { text: this.$t('headers.status'), align: 'left', value: 'status', sortable: false, filterable: false },
        { text: this.$t('headers.actions'), align: 'right', value: 'actions', sortable: false, filterable: false },
      ],

      // Add Participant
      userId: 0,
      brokerAccountId: 0,
      userVerifiedBrokerAccounts: [],

      // Change Status
      currentParticipant: null,
    };
  },
  mounted() {
    this.verifyCanSeeJournal();
  },
  methods: {
    getStatus(status) {
      if(status !== null) {
        switch (status) {
          case 'ACTIVE':
            return this.$t('status.active');
          case 'DISQUALIFIED':
            return this.$t('status.disqualified');
          case 'PAUSED':
            return this.$t('status.paused');
          case 'WINNER':
            return this.$t('status.winner');
        }
      }
    },
    verifyCanSeeJournal() {
      let startTime = new Date(this.$store.state.tournament.startTime);
      let endTime = new Date(this.$store.state.tournament.endTime);
      endTime.setDate(endTime.getDate() + 7);
      this.canSeeJournal = startTime < new Date() && new Date() < endTime;
    },
    ...mapMutations(['setTournament']),
    updateTournament() {
      RepositoryTournament.getTournamentOverview(this.$store.state.tournament.tournamentId).then((response) => {
        if(response.status < 400)
          this.setTournament(response.data);
      });
    },
    ...mapMutations(['setShare']),
    seeJournal(participant) {
      let sharingDetails = {
        id: participant.userId,
        username: participant.username,
        imageUrl: participant.imageUrl,
        firstName: participant.firstName,
        lastName: participant.lastName,
        country: participant.country,
        allowComments: false,
      };
      this.setShare(sharingDetails);
      this.$router.push('/book/shared');
    },
    async changedSelectedUser() {
      this.userVerifiedBrokerAccounts = [];
      let alreadyEnrolled;

      await RepositoryTournament.findParticipantByTournament(this.tournamentSummary.tournamentId, this.userId).then(async (response) => {
        if(response.status < 400)
          alreadyEnrolled = await response.data !== null;
      });

      if(alreadyEnrolled)
        alert(this.$t('alerts.alreadyEnrolled'));
      else
        RepositoryBroker.allBrokerAccountsOfExternalUser(this.userId).then((response) => {
          if(response.status < 400) {
            this.userVerifiedBrokerAccounts = response.data.filter((account) => account.verified);
            if(this.userVerifiedBrokerAccounts.length === 0)
              alert(this.$t('alerts.notVerified'));
          }
        });
    },
    ...mapMutations(['setTournament']),
    addParticipant() {
      this.overlayProcessing = true;
      let tournamentParticipant = {
        tournament: { id: this.tournamentSummary.tournamentId },
        assignedAccount: { id: this.brokerAccountId },
        user: { id: this.userId },
      };

      RepositoryTournament.enrollParticipant(tournamentParticipant).then((response) => {
        if(response.status < 400) {
          alert(this.$t('alerts.added', { userId: this.userId }));
          this.updateTournament();
          this.view = 'GENERAL';
          this.overlayProcessing = false;
        }
      });
    },
    goToUser(participant, action) {
      this.view = action;
      this.currentParticipant = participant;
    },
    activateUser() {
      this.overlayProcessing = true;
      RepositoryTournament.changeParticipantStatus(this.currentParticipant.participantId, 'ACTIVE').then((response) => {
        if(response.status < 400) {
          alert(this.$t('alerts.activated', { userId: this.userId }));
          this.updateTournament();
          this.view = 'GENERAL';
          this.overlayProcessing = false;
        }
      });
    },
    disqualifyUser() {
      this.overlayProcessing = true;
      RepositoryTournament.changeParticipantStatus(this.currentParticipant.participantId, 'DISQUALIFIED').then((response) => {
        if(response.status < 400) {
          alert(this.$t('alerts.disqualified', { userId: this.userId }));
          this.updateTournament();
          this.view = 'GENERAL';
          this.overlayProcessing = false;
        }
      });
    },
    statusColor(status) {
      if(status === 'ACTIVE')
        return '#00F784';
      if(status === 'DISQUALIFIED')
        return '#ff9fa7';
      return '#FFF75F';
    },
    capitalize(string) {
      return string[0].toUpperCase() + string.slice(1).toLowerCase();
    },
    exportCSV() {
      let rows = [['Trader First Name', 'Trader Last Name', 'Trader Email', 'Score', 'Status'],];

      this.$store.state.tournament.participants.forEach((participant) => {
        rows.push([
          `${participant.firstName}`,
          `${participant.lastName}`,
          `${participant.email}`,
          `${(participant.score === null)? '0' : participant.score}`,
          `${participant.status}`,
        ]);
      });
      let csvContent = "data:text/csv;charset=utf-8," + rows.map(e => e.join(",")).join("\n");

      // Encoding and data downloading
      let encodedUri = encodeURI(csvContent);
      let link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "Tournament Participants.csv");
      document.body.appendChild(link);
      link.click();
      alert(this.$t('alerts.successfulDownload', { members: rows.length - 1 }));
    },
    close() {
      this.$emit('closeWindow');
    },
  }
}
</script>

<i18n>
{
  "en": {
    "title": "Tournament Participants",
    "subtitle": "Participants",
    "btnAdd": "Add",
    "hintSearch": "Search by name, email or username",
    "headers": {
      "name": "First Name",
      "email": "Email",
      "username": "Username",
      "score": "Score",
      "status": "Status",
      "actions": "Actions"
    },
    "status": {
      "active": "Active",
      "disqualified": "Disqualified",
      "paused": "Paused",
      "winner": "Winner"
    },
    "btnDisqualify": "Disqualify User",
    "btnActivate": "Activate User",
    "btnSeeJournal": "See Journal",
    "add": {
      "title": "Add Participant",
      "description": "Select a user and register with a verified broker account",
      "emailLabel": "User Email",
      "emailPlaceholder": "Select a user by email",
      "accountLabel": "User Broker Account",
      "accountPlaceholder": "Select user broker account",
      "btnAll": "All Participants",
      "btnAdd": "Add Participant"
    },
    "option": {
      "titleDisqualify": "Disqualify Participant",
      "titleActivate": "Activate Participant",
      "descriptionDisqualify": "Do you want to disqualify {name}?",
      "descriptionActivate": "Do you want to activate {name}?",
      "btnAll": "All Participants",
      "btnDisqualify": "Disqualify {name}",
      "btnActivate": "Activate {name}"
    },
    "alerts": {
      "alreadyEnrolled": "User is already enrolled to the tournament.",
      "notVerified": "User doesn't have verified accounts.\nA verified account is required to be part of any tournament.",
      "added": "User {userId} was successfully registered to the tournament!",
      "disqualified": "User {userId} was successfully disqualified!",
      "activated": "User {userId} was successfully activated again!",
      "successfulDownload": "List was exported with {members} members included"
    },
    "btnDownload": "Download Members",
    "btnClose": "Close"
  },
  "es": {
    "title": "Participantes del Torneo",
    "subtitle": "Participantes",
    "btnAdd": "Agregar",
    "hintSearch": "Buscar por nombre, email o usuario",
    "headers": {
      "name": "Nombre",
      "email": "Email",
      "username": "Usuario",
      "score": "Puntaje",
      "status": "Estado",
      "actions": "Acciones"
    },
    "status": {
      "active": "Activo",
      "disqualified": "Descalificado",
      "paused": "Pausado",
      "winner": "Ganador"
    },
    "btnDisqualify": "Descalificar Usuario",
    "btnActivate": "Activar Usuario",
    "btnSeeJournal": "Ver Bitácora",
    "add": {
      "title": "Agregar Participante",
      "description": "Selecciona un usuario y regístralo con una cuenta de broker verificada",
      "emailLabel": "Email del Usuario",
      "emailPlaceholder": "Selecciona un usuario por su email",
      "accountLabel": "Cuenta de Broker del Usuario",
      "accountPlaceholder": "Selecciona la cuenta de broker del usuario",
      "btnAll": "Todos los Participantes",
      "btnAdd": "Agregar Participante"
    },
    "option": {
      "titleDisqualify": "Descalificar Participante",
      "titleActivate": "Activar Participante",
      "descriptionDisqualify": "¿Quieres descalificar a {name}?",
      "descriptionActivate": "¿Quieres activar a {name}?",
      "btnAll": "Todos los Participantes",
      "btnDisqualify": "Descalificar a {name}",
      "btnActivate": "Activar a {name}"
    },
    "alerts": {
      "alreadyEnrolled": "Usuario ya se encuentra registrado en el torneo.",
      "notVerified": "Usuario no cuenta con cuentas verificadas.\nUna cuenta verificada es obligatoria para ser parte de cualquier torneo.",
      "added": "¡Usuario {userId} fue satisfactoriamente registrado al torneo!",
      "disqualified": "¡Usuario {userId} fue satisfactoriamente descalificado!",
      "activated": "¡Usuario {userId} fue satisfactoriamente activado de nuevo!",
      "successfulDownload": "Lista fue exportada con {members} miembros incluídos"
    },
    "btnDownload": "Descargar Miembros",
    "btnClose": "Cerrar"
  }
}
</i18n>

<style scoped>
  .button-add {
    background-color: #111111 !important;
    color: #ffffff !important;
    border: #111111 solid 1px;
  }
</style>
